import { IInstructionDTO } from '../../dto/instruction/instruction.dto';
import { IInstructionStepDTO } from '../../dto/instruction/instruction-step.dto';

const instructionStepDTOs: IInstructionStepDTO[] = [
  {
    title: $localize`:@@page-photo-downloader-content-instruction-section-step-0-title:Copy the URL`,
    description: $localize`:@@page-photo-downloader-content-instruction-section-step-0-description:Navigate to the Instagram post you wish to download. Copy the URL of the post from your browser’s address bar.`,
  },
  {
    title: $localize`:@@page-photo-downloader-content-instruction-section-step-1-title:Paste the URL`,
    description: $localize`:@@page-photo-downloader-content-instruction-section-step-1-description:Go to our Instagram photo downloader tool. Paste the copied URL into the designated field on our website.`,
  },
  {
    title: $localize`:@@page-photo-downloader-content-instruction-section-step-2-title:Click download`,
    description: $localize`:@@page-photo-downloader-content-instruction-section-step-2-description:Hit the "Download" button. Our tool will process the URL and prepare the image for download.`,
  },
  {
    title: $localize`:@@page-photo-downloader-content-instruction-section-step-3-title:Enjoy your photos`,
    description: $localize`:@@page-photo-downloader-content-instruction-section-step-3-description:Access and enjoy your downloaded Instagram photos anytime, anywhere.`,
  },
];

export const instructionDTO: IInstructionDTO = {
  title: $localize`:@@page-photo-downloader-content-instruction-section-title:How to download Instagram photos using our tool`,
  header: $localize`:@@page-photo-downloader-content-instruction-section-header:Downloading Instagram photos with our tool is straightforward and quick. Follow these simple steps to start saving your favorite images:`,
  steps: instructionStepDTOs,
  footer: $localize`:@@page-photo-downloader-content-instruction-section-footer:With our Instagram photo downloader, saving your favorite Instagram images has never been easier. Experience the convenience and efficiency of our tool today!`,
};
